import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, Form, Overlay, Popover } from "react-bootstrap";

const InputText = (props: any) => {
  const [showHelper, setShowHelper] = useState(false);
  const [targetHelper, setTargetHelper] = useState(null);

  const onControlChange = (e: any) => {
    if (props.SuscribedChange) props.SuscribedChange(e.target.value);
  };

  const onClickClean = (e: any) => {
    if (props.handlerClean) props.handlerClean(e);
  };

  const handlerClickHelper = (e: any) => {
    setShowHelper(!showHelper);
    setTargetHelper(e.target);
  }

  return (
    <>
      {/* <Form.Group
        className={`justify-content-center ${props.ClassGroup || ""}`}
      > */}
        <Form.Label className={`font-label-form ${(!(props.Label)) ? 'd-none' : ''}`}>
          {props.Label || ""}
          {
            props.Helper
              ?
              <>
                <img
                  src={"img/questionmarkicon.png"}
                  alt="questionmark"
                  className="dashboard-questionmark-size"
                  onClick={(e) => handlerClickHelper(e)}
                />
                <Overlay
                  show={showHelper}
                  target={targetHelper}
                  placement={"right"}
                  >
                    <Popover>
                      <Popover.Body>
                        {props.Helper || ''}
                      </Popover.Body>
                    </Popover>
                </Overlay> 
              </>
              : <></>
          }
        </Form.Label>

        {/* <img
          src={"img/questionmarkicon.png"}
          alt="questionmark"
          className="question-mark"
        /> */}
        <Form.Control
          size="sm"
          type="text"
          maxLength={props.MaxLength ? props.MaxLength : Number.MAX_VALUE}
          placeholder={props.Placeholder || ""}
          disabled={props.Disabled || false}
          onChange={(e: any) => onControlChange(e)}
          className={`${props.ClassName || ""}`}
          defaultValue={props.DefaultValue || ""}
        />
        {
          props.handlerClean ?
            <Button type="button" variant="outline-dark" size="sm" onClick={(e: any) => onClickClean(e)}>
              <FontAwesomeIcon icon={"trash-alt"} />
            </Button>          
          : <></>
        }
      {/* </Form.Group> */}
    </>
  );
};

export default InputText;